import React, { FC } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  FormControl,
  Input,
  InputAdornment,
  InputLabel
} from "@material-ui/core";
import MuiIconButton from "@material-ui/core/IconButton";
import IconSearch from "@material-ui/icons/Search";

const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  }
}));

export const TableSearch: FC<{ onChange: (value: string) => void }> = ({
  onChange
}) => {
  const classes = useStyles();

  return (
    <FormControl className={classes.formControl}>
      <InputLabel>Search</InputLabel>
      <Input
        type="text"
        placeholder="Search..."
        onChange={event => onChange(event.target.value)}
        endAdornment={
          <InputAdornment position="end">
            <MuiIconButton>
              <IconSearch />
            </MuiIconButton>
          </InputAdornment>
        }
      />
    </FormControl>
  );
};
